var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatbubbleQuestionFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#chatbubble-question-fill_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M17.177 1.262A11.921 11.921 0 0 0 1.834 18.228L.132 22.762a.857.857 0 0 0 .953 1.145l5.942-1.075a11.92 11.92 0 1 0 10.15-21.57m-4.844 6.26a1.706 1.706 0 0 0-2.04 1.673 1.07 1.07 0 1 1-2.143 0 3.849 3.849 0 1 1 4.92 3.698v.933a1.072 1.072 0 0 1-2.143 0v-1.852c0-.593.48-1.071 1.073-1.071a1.706 1.706 0 0 0 .333-3.38M12 19.526a1.535 1.535 0 0 1 .003-3.069h.004a1.534 1.534 0 1 1-.004 3.069z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "chatbubble-question-fill_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgChatbubbleQuestionFill;